import { render, staticRenderFns } from "./Verification.vue?vue&type=template&id=55fe73e4"
import script from "./Verification.vue?vue&type=script&lang=js"
export * from "./Verification.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/atlassian/pipelines/agent/build/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('55fe73e4')) {
      api.createRecord('55fe73e4', component.options)
    } else {
      api.reload('55fe73e4', component.options)
    }
    module.hot.accept("./Verification.vue?vue&type=template&id=55fe73e4", function () {
      api.rerender('55fe73e4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/patient/auth/Verification.vue"
export default component.exports